import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Header.scss";
import BreadcrumbsMenu from "./BreadcrumbsMenu";
import SelectButtons from "./SelectButton/SelectButtons";
import ApplyFilter from "./ApplyFilter/ApplyFilter";
import NotificationWithBadge from "./NotificationWithBadge";
import AdvanceSearchComponent from "../../Layout/Master/MasterUtils/Components/AdvanceSearch/AdvanceSearchComponent";

const Header = () => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  // removign the advance search feature as scoped out in sprint 31
  const isScoped = false;

  useEffect(() => {
    setIsVisible(location.pathname === "/dashboard");
  }, [location.pathname]);

  return (
    <div className="cockpit-header" data-testid="header">
      <div className="grid align-items-center flex m-0" >
        <div className="sm:col-12 md:col-6 dashboardfontstyle">
          <BreadcrumbsMenu />
        </div>
        <div className="sm:col-12 md:col-6 flex flex-wrap align-items-center justify-content-end pr-2 ">
          {isVisible && <div style={{marginRight:"1rem"}}  data-testid="select-buttons"><SelectButtons /></div>}
          {isVisible && <div style={{marginRight:"1rem"}} data-testid="apply-filter"> <ApplyFilter /></div>}
          {isVisible && <NotificationWithBadge data-testid="notification-badge"/>}
          {isScoped && <AdvanceSearchComponent data-testid="advance-search"/>}
        </div>
      </div>
    </div>
  )
}
export default Header;
